export default {
      id: "icon-kind-usage",
      viewBox: "0 0 306.2 207.1",
      url: __webpack_public_path__ + "img/icons.33fd9142.svg#icon-kind",
      toString: function () {
        return this.url;
      }
    }